import { mergeRight, findLastIndex, propEq } from "ramda";
import { isPropNotEmpty, isPropNilOrEmpty } from "../object";

const transformRequirements = (
  requirements = [],
  statusGetter,
  adventures = {},
  awards = {}
) =>
  requirements.map((requirement) => {
    let linkedAdventure = {};
    let linkedAward = {};
    if (
      isPropNotEmpty(requirement, "linkedAdventureId") &&
      isPropNilOrEmpty(requirement, "linkedAdventure")
    ) {
      linkedAdventure =
        adventures[
          findLastIndex(propEq("id", +requirement.linkedAdventureId))(
            adventures
          )
        ];
    } else if (
      isPropNotEmpty(requirement, "linkedAwardId") &&
      isPropNilOrEmpty(requirement, "linkedAward")
    ) {
      linkedAward =
        awards[findLastIndex(propEq("id", requirement.linkedAwardId))(awards)];
    }
    let { status } = requirement;
    if (statusGetter) {
      status = statusGetter(requirement);
    }

    return mergeRight(requirement, {
      status,
      dateCompleted: requirement.dateCompleted || "",
      dateStarted: requirement.dateStarted || "",
      linkedAdventure: isPropNilOrEmpty(requirement, "linkedAdventure")
        ? linkedAdventure
        : requirement.linkedAdventure,
      linkedAward: isPropNilOrEmpty(requirement, "linkedAward")
        ? linkedAward
        : requirement.linkedAward,
    });
  });

export default transformRequirements;
